import React, { useEffect, useState } from "react";
import "./Campaigns.css";
import config from "../../../../config";

import CampaignFilters from "./CampaignFilters";
import CampaignProductPreview from "./CampaignProductPreview";

export default function CampaignRuleModal({
  campaign,
  onClose,
  onSuccess,
}) {

  const [saving, setSaving] = useState(false);

  // Category Master Data
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(true);

const [filters, setFilters] = useState({
  categoryId: null,
  categoryName: "",

  subCategoryId: null,
  subCategoryName: "",

  sellerId: null,
  brand: "",

  minPrice: "",
  maxPrice: "",
  minDiscount: "",
  maxDiscount: "",

  sortBy: "",
});

  /**
   * Load Categories
   */
  useEffect(() => {

    const fetchCategories = async () => {

      try {

        setCategoriesLoading(true);

        const response = await fetch(
          `${config.baseUrl}/api/categories`
        );

        if (response.ok) {

          const data = await response.json();
          setCategories(data || []);

        }

      } catch (err) {

        console.error("Failed to fetch categories", err);

      } finally {

        setCategoriesLoading(false);

      }

    };

    fetchCategories();

  }, []);

  /**
   * Load Sub Categories whenever Category changes
   */
  useEffect(() => {

    if (!filters.categoryName) {

      setSubCategories([]);
      return;

    }

    const fetchSubCategories = async () => {

      try {

        const response = await fetch(
          `${config.baseUrl}/api/subCategories/category/${encodeURIComponent(filters.categoryName)}`
        );

        if (response.ok) {

          const data = await response.json();
          setSubCategories(data || []);

        } else {

          setSubCategories([]);

        }

      } catch (err) {

        console.error("Failed to fetch sub categories", err);
        setSubCategories([]);

      }

    };

    fetchSubCategories();

  }, [filters.categoryName]);

  /**
   * Load existing campaign rule
   */
  useEffect(() => {

    if (!campaign) return;

    if (campaign.rule) {

setFilters({
    categoryId: campaign.rule.categoryId || null,
    categoryName: campaign.rule.categoryName || "",

    subCategoryId: campaign.rule.subCategoryId || null,
    subCategoryName: campaign.rule.subCategoryName || "",

    sellerId: campaign.rule.sellerId || null,
    brand: campaign.rule.brand || "",

    minPrice: campaign.rule.minPrice || "",
    maxPrice: campaign.rule.maxPrice || "",

    minDiscount: campaign.rule.minDiscount || "",
    maxDiscount: campaign.rule.maxDiscount || "",

    sortBy: campaign.rule.sortBy || "",
});

    }

  }, [campaign]);

  /**
   * Save Campaign Rule
   */
  const handleSave = async () => {

    try {

      setSaving(true);

      const response = await fetch(
        `${config.baseUrl}/admin/campaign-rules/${campaign.id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
body: JSON.stringify({

    categoryId: filters.categoryId,
    subCategoryId: filters.subCategoryId,

    sellerId: filters.sellerId || null,
    brand: filters.brand || null,

    minPrice: filters.minPrice || null,
    maxPrice: filters.maxPrice || null,

    minDiscount: filters.minDiscount || null,
    maxDiscount: filters.maxDiscount || null,

    sortBy: filters.sortBy || null

}),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to save campaign rule");
      }

      alert("Campaign rule saved successfully.");

      onSuccess();

    } catch (err) {

      console.error(err);
      alert(err.message);

    } finally {

      setSaving(false);

    }

  };

  return (

    <div className="modal-overlay">

      <div className="modal-content large-modal">

        <div className="modal-header">

          <h2>Campaign Rules</h2>

          <button
            className="close-btn"
            onClick={onClose}
          >
            ×
          </button>

        </div>

        <div className="modal-body">

          <div className="payload-box">

            <h3>Campaign Information</h3>

            <div className="form-grid">

              <div className="form-group">
                <label>Campaign Name</label>
                <input
                  value={campaign.name}
                  disabled
                />
              </div>

              <div className="form-group">
                <label>Campaign Type</label>
                <input
                  value={campaign.campaignType}
                  disabled
                />
              </div>

              <div className="form-group">
                <label>Status</label>
                <input
                  value={campaign.status}
                  disabled
                />
              </div>

            </div>

          </div>

          <div className="payload-box">

            <h3>Rule Builder</h3>

            <CampaignFilters
              filters={filters}
              onChange={setFilters}
              categories={categories}
              subCategories={subCategories}
              categoriesLoading={categoriesLoading}
            />

          </div>

          <div className="payload-box">

            <h3>Matching Products</h3>

            <CampaignProductPreview
              campaign={campaign}
              filters={filters}
            />

          </div>

        </div>

        <div className="modal-actions">

          <button onClick={onClose}>
            Cancel
          </button>

          <button
            className="btn-primary"
            disabled={saving}
            onClick={handleSave}
          >
            {saving
              ? "Saving..."
              : "Save Rules"}
          </button>

        </div>

      </div>

    </div>

  );

}